import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-product",
  "use": "icon-product-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"icon-product\"><path d=\"M8 18h6v2H8z\" fill=\"currentColor\" /><path d=\"M8 22h10v2H8z\" fill=\"currentColor\" /><path d=\"M26 4H6a2.002 2.002 0 0 0-2 2v20a2.002 2.002 0 0 0 2 2h20a2.002 2.002 0 0 0 2-2V6a2.002 2.002 0 0 0-2-2zm-8 2v4h-4V6zM6 26V6h6v6h8V6h6l.001 20z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol